const pre = '/bcos/system/';

export default {
    path: '/bcos/system',
    title: '系统管理',
    header: '',
    icon: 'md-settings',
    children: [
        {
            path: `${pre}permission`,
            title: '权限管理',
        },
        {
            path: `${pre}config`,
            title: '配置管理',
        },
        {
            path: `${pre}cert`,
            title: '证书管理',
        },
    ]
}
